..
<template>
    <div class="form">
        <a-card :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <a-form-model :model="domainData" ref="ruleForm" :rules="rules" :layout="formItemLayout"
                          :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-form-model-item ref="uid" label="用户UID" prop="uid">
                    <span class="form_span">{{ domainData.uid }}</span>
                </a-form-model-item>
                <a-form-model-item ref="username" label="用户名称" prop="username">
                    <span class="form_span">{{ domainData.username }}</span>
                </a-form-model-item>

                <!--                <a-form-model-item ref="identitytype" label="授权类型" prop="identitytype">-->
                <!--                    <span class="form_span">{{ domainData.identitytypename }}</span>-->
                <!--                </a-form-model-item>-->

<!--                <a-form-model-item ref="oldcertificate" label="原密码" prop="oldcertificate">-->
                <!--                    <a-input v-model="domainData.oldcertificate" @blur="-->
                <!--                        () => {-->
                <!--                            $refs.oldcertificate.onFieldBlur();-->
                <!--                        }-->
                <!--                        "/>-->
                <!--                </a-form-model-item>-->
                <a-form-model-item ref="newcertificate" label="新密码" prop="newcertificate">
                    <a-input v-model="domainData.newcertificate" type="password"  @blur="
                        () => {
                            $refs.newcertificate.onFieldBlur();
                        }
                        "/>
                </a-form-model-item>
                <a-form-model-item ref="newcertificate1" label="重复输入"  prop="newcertificate1">
                    <a-input v-model="domainData.newcertificate1" type="password" @blur="
                        () => {
                            $refs.newcertificate1.onFieldBlur();
                        }
                        "/>
                </a-form-model-item>

                <a-form-model-item :wrapper-col="{ span: 8, offset: 12 }">
                    <a-button type="primary" @click="handleOk">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>
        </a-card>
    </div>
</template>

<script>
const m_title = {
    'userauthitem': '修改用户授权'
};
const authMap = {
    1: '账号密码',
    2: '手机号',
    3: '中伦网络公众号',
}
export default {
    data() {
        return {
            m_title,
            authMap,
            c_title: '',
            labelCol: {span: 6},
            wrapperCol: {span: 8},
            rules: {
                // oldcertificate: [
                //     {required: true, message: '请输入原密码', trigger: 'blur'},
                //     {min: 6, max: 50, message: '请输入6~20个字符', trigger: 'blur'},
                // ],
                newcertificate: [
                    {required: true, message: '请输入新密码', trigger: 'blur'},
                    {min: 6, max: 50, message: '请输入6~20个字符', trigger: 'blur'},
                ]
                , newcertificate1: [
                    {required: true, message: '请重复输入新密码', trigger: 'blur'},
                    {min: 6, max: 50, message: '请输入6~20个字符', trigger: 'blur'},
                ]
            },
            confirmLoading: false,
            formItemLayout: 'horizontal',
            domainData: {},
            selecterState: {
                isShow: false,
                rowsType: 'radio' // or 'checkbox'，单选或多选
            },
            is_vue_task: true,
        };
    },
    components: {},

    methods: {
        handleOk() {
            let that = this;
            that.$refs.ruleForm.validate(valid => {
                if (valid) {

                    if (that.domainData.newcertificate1 != that.domainData.newcertificate) {
                        that.message.error("新密码输入不一致！")
                    } else {
                        that.confirmLoading = true;
                        console.log(that.domainData);
                        // const {params} = that.$route;
                        //编辑
                        // that.domainData.urlparams = false;
                        that.$store
                            .dispatch({
                                type: "ums/updateUserAuth4Fp",
                                params: that.domainData,
                                
                            })
                            .then((response) => {
                                if (response.data.success == '1') {
                                    console.log(response)
                                    that.handleCancel()
                                    that.confirmLoading = false;
                                }
                            });
                    }

                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },
    mounted() {
        const {query, params} = this.$route;

        let that = this;
        if (params.action != "adduser") {
            that.domainData.uid = query.uid
            that.domainData.username = query.username
            that.domainData.identitykey = query.identitykey
            that.c_title = "正在修改【" + query.username + "】的【" + authMap[query.identitytype] + "】授权"
            // that.domainData.identitytypename =

        }

    }
};
</script>

<style lang="less" scoped>
.form_span {
    font-size: 14px;
    font-weight: bolder;
}
</style>
